import { jsx as _jsx } from "react/jsx-runtime";
import { map, findIndex } from 'lodash-es';
import { useCallback, useState } from 'react';
import { mountComponentByClassWithData } from '../common/mount-helpers';
import { VideoSlider } from '../components/video-slider';
function RecentListingsVideoSlider(props) {
    const { listings } = props;
    const [currentListingId, setCurrentListingId] = useState(listings[0].id);
    const updateCurrentListingByIndex = useCallback((index) => {
        setCurrentListingId(listings[index].id);
    }, [listings, setCurrentListingId]);
    return (_jsx("div", { className: "recent-listings-video-slider", children: _jsx(VideoSlider, { videos: map(listings, listing => ({
                src: listing.wistiaVideoUrl,
                poster: listing.videoThumbnail ??= listing.gallery[0].url,
            })), currentSlideIndex: findIndex(listings, { id: currentListingId }), updateCurrentSlideIndex: updateCurrentListingByIndex }) }));
}
window.addEventListener('load', () => {
    mountComponentByClassWithData('recent-listings-video-slider-wrapper', (props) => _jsx(RecentListingsVideoSlider, { ...props }));
});
